import ColorNameMapper from '../../../svgchartlib-v3/includes/primitives/Color_Data'

export default ColorNameMapper